
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smartphone/[slug]/[reference]",
      function () {
        return require("private-next-pages/smartphone/[slug]/[reference].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smartphone/[slug]/[reference]"])
      });
    }
  